
import styled from 'styled-components';
const Styles = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
  overflow-y: auto;
  
	.ant-descriptions-bordered .ant-descriptions-view {
		table {
			table-layout: fixed;
		}
	}
	.ant-tabs .ant-tabs-left-bar .ant-tabs-tab,
	.ant-tabs .ant-tabs-right-bar .ant-tabs-tab {
		text-align: start;
	}
	.missing {
		color: red;
  }
  .multiple-card-view.ant-card-small > .ant-card-body {
    padding: 0;
    .ant-descriptions {
      padding: 0;
    }
  }
  .ant-tabs .ant-tabs-left-content, .ant-tabs .ant-tabs-right-content{
    height: 100%;
    overflow-y: auto;
  }
  .ant-tabs .ant-tabs-tabpane {
    outline: none;
    overflow-y: auto;
  }
  .d-flex-space{
    display: flex;
    justify-content: space-between;
  }
  .group-header{
			font-family: SF UI Display;
			color: var(--color-primary-70);
      position: relative;
      button{
        top: -4px;
        left: -3px;
      }
      span.bg-white{
        background: white
      }
			&::after {
				content: '';
				position: absolute;
				width: 100%;
				height: 1px;
				background: #F4F5F8;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				margin: auto;
				z-index: -1;
			}
    }
  .no-top-border>.ant-descriptions-view {
    border-top: none;
  }
  .ant-descriptions-item-label.as-title {
    font-family: "SF UI Display" !important;
    font-weight: 600 !important;
    font-size: 18px !important;
    line-height: 26px !important;
    background: none;
    border: none;
    padding: var(--size);
  }
  .ant-descriptions-row {
    th.no-label {
      display: none!important;
    }
    td.no-label {
      display: table-cell;
      width: 100%;
    }
  }
  .title-semibold-3, .title-semibold-4 {
    margin-top: 14px !important;
    font-size: var(--font-size-lg) !important;
    font-weight: 600 !important;
  }
  .ant-row {
    margin: 0 !important;
  }
  .ant-col.ant-col-xs-24.ant-col-sm-24.ant-col-md-24.ant-col-lg-24.ant-col-xl-24.ant-col-xxl-24 {
    padding: 0 !important;
  }
`;
export default Styles;
